import React from 'react'

export default function Header () {
  return (
    <div className="c-heading">
        <span className="c-heading__logo c-heading__logo--wtc logo"></span>
    </div>
  )
}
